import { ROLES } from '../../containers/TeamsManagement/constants'
import { badgeColorOptions } from '../stories/atoms/badges/constants'

export const copyProjectMembersTabOptions = {
  MEMBERS: 'members',
  TEAMS: 'teams',
  CONTACTS: 'contacts'
}

export const copyProjectMembersTabs = Object.values(
  copyProjectMembersTabOptions
)

export const copyProjectMembersSelectionOptions = {
  ALL: 'ALL',
  NONE: 'none',
  CUSTOM: 'custom',
  EMPTY: 'empty'
}

export const copyProjectTeamGroupsSelectionModeOptions = {
  INCLUDE: 'include',
  EXCLUDE: 'exclude'
}

export const handleRoleColor = (role) => {
  switch (role) {
    case ROLES.POWERUSER:
      return badgeColorOptions.VIOLET
    case ROLES.ASSISTANT:
      return badgeColorOptions.BLUE
    case ROLES.EXTERNALVISITOR:
      return badgeColorOptions.TURQUOISE
    case ROLES.SUBCONTRACTOR:
      return badgeColorOptions.OCHRE
    case ROLES.VIEWER:
      return badgeColorOptions.GREEN
    default:
      return badgeColorOptions.OCHRE
  }
}
